import React from "react";
import PropTypes from "prop-types";
import { DropDownList } from "@progress/kendo-react-dropdowns";

class DropDownCell extends React.Component {
  handleChange = e => {
    const { onChange, dataItem, field, realKey, changeCallback } = this.props;
    onChange({
      dataItem,
      field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value[realKey]
    });
    if (changeCallback && field !== "Agricultural")
      changeCallback({ ...dataItem, [field]: e.target.value[realKey] });
  };

  render() {
    const { displayKey, field } = this.props;
    const dataValue = this.props.dataItem[this.props.field];

    let error = null;
    if (
      this.props.dataItem.errors &&
      this.props.dataItem.errors[this.props.field]
    ) {
      error = this.props.dataItem.errors[this.props.field];
    }

    if (field === "Suspend" && this.props.dataItem.WeightCategory === "W") {
      return <td>Yes</td>;
    }

    if (!this.props.dataItem.inEdit) {
      if (dataValue !== undefined && dataValue !== null) {
        const dropdownItem = this.props.localizedData.find(
          c => c[this.props.realKey] === dataValue
        );

        if (dropdownItem) {
          return <td>{dropdownItem[displayKey]}</td>;
        }
        return <td>None</td>;
        // const displayVal = this.props.localizedData.find(
        //   c => c[this.props.realKey] === dataValue
        // )[displayKey];
        // return <td>{displayVal}</td>;
      }
      return <td>None</td>;
    }

    return (
      <td {...this.props}>
        <DropDownList
          className="dropdown-cell"
          popupSettings={{
            width: "auto"
          }}
          defaultItem={{
            [this.props.displayKey]: "(none)",
            [this.props.realKey]: null
          }}
          style={{ width: "100%" }}
          onChange={this.handleChange}
          value={this.props.localizedData.find(
            c => c[this.props.realKey] === dataValue
          )}
          data={this.props.localizedData}
          textField={this.props.displayKey}
        />
        {error && <span className="i2290-inline-error">{error}</span>}
      </td>
    );
  }
}

DropDownCell.propTypes = {
  changeCallback: PropTypes.func,
  dataItem: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  displayKey: PropTypes.string,
  realKey: PropTypes.string
};

DropDownCell.defaultProps = {
  displayKey: "display",
  realKey: "real",
  changeCallback: null
};

export default DropDownCell;
